<template>
  <div class="balances">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="txt-div">
          <div class="txt1">{{item.examine_status_text}}</div>
          <div class="txt2">¥{{item.money}}</div>
        </div>
        <div class="txt-div">
          <div class="txt3">{{item.create_time}}</div>
          <div class="txt3">订单金额(元)</div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { withdrawalLog } from '@/api/person'
export default {
  name: 'balances',
  data () {
    return {
      details: {},
      list: [],
      loading: false,
      finished: false,
      page: 1,
      num: 10
    }
  },
  mounted () {
  },
  methods: {
    onLoad() {
      withdrawalLog({
        page: this.page,
        num: this.num,
      }).then(res => {
        console.log(res)
        if (res.data.length < this.num) {
          this.finished = true
        }
        this.list = this.list.concat(res.data)
        this.page++
        // 加载状态结束
        this.loading = false
      })
    },
  }
}
</script>
<style lang="less" scoped>
.balances {
  padding: 20px 14px;
  width: 100vw;
  min-height: 100vh;
  background-color: #1E2020;
  box-sizing: border-box;
  overflow: hidden;

  .deta-con {
    border-radius: 6px;
    background-color: #292B2A;
    margin-bottom: 14px;
    position: relative;

    .img-head {
      width: 60px;
      height: 60px;
      display: block;
      margin-bottom: 14px;
      margin-left: 50%;
      transform: translateX(-50%);
      position: relative;
      top: -30px;
      border-radius: 50%;
    }

    .txt1 {
      color: #FFFFFF;
      font-size: 20px;
      text-align: center;
      font-weight: 600;
      margin-bottom: 12px;
      line-height: 20px;
      margin-top: -30px;
    }

    .txt2 {
      font-size: 12px;
      color: #999999;
      font-weight: 500;
      margin-bottom: 12px;
      text-align: center;
    }

    .txt3 {
      width: 68px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      line-height: 20px;
      box-sizing: border-box;
      border-radius: 100px;
      border: 1px solid #E0C894;
      font-size: 12px;
      color: #E0C894;
      margin-left: 50%;
      transform: translateX(-50%);
    }

    .flex-div {
      display: flex;
      height: 90px;
      align-items: center;

      .nav-dix {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        position: relative;

        &:first-child::before {
          position: absolute;
          right: 0;
          top: 0;
          height: 50px;
          border-right: 1px dashed #3C3F3D;
          box-sizing: border-box;
          content: "";
        }

        .nav-txt1 {
          font-size: 20px;
          color: #FFFFFF;
          font-weight: 500;
          line-height: 20px;
          margin-bottom: 12px;

          &.cur {
            color: #F0E1C0;
          }
        }

        .nav-txt2 {
          color: #999999;
          line-height: 12px;
          font-size: 12px;
        }
      }
    }
  }

  .list {
    background-color: #292B2A;
    border-radius: 6px 6px 0px 0px;
    padding: 0 14px;
    box-sizing: border-box;

    .item {
      padding: 20px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #666666;

      &:last-child {
        border: none;
      }

      .txt-div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 16px;

        .txt1 {
          font-size: 16px;
          color: #FFFFFF;
        }

        .txt2 {
          font-size: 16px;
          color: #F0E1C0;
        }

        .txt3 {
          font-size: 12px;
          color: #999999;
          line-height: 8px;
          margin-top: 8px;
        }
      }
    }
  }
}</style>



// WEBPACK FOOTER //
// src/views/personal/balances.vue